import { interopDefault } from '~/utils';
import RouteEnum from '~/enums/RouteEnum';

export default [
  {
    path: '/organizations',
    name: RouteEnum.ORGANIZATIONS.INDEX,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'tenantmember:organizations.index' */ '~/pages/tenantmember/organizations/index.vue'
        )
      ),
  },
  {
    path: '/organizations/create',
    name: RouteEnum.ORGANIZATIONS.CREATE,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'tenantmember:organizations.create' */ '~/pages/tenantmember/organizations/create.vue'
        )
      ),
  },
  {
    path: '/organizations-progress',
    name: RouteEnum.ORGANIZATIONS_PROGRESS.INDEX,
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'tenantmember:organizations-progress.index' */ '~/pages/tenantmember/organizations-progress/index.vue'
        )
      ),
  },
  {
    path: '/organizations/:id',
    component: () =>
      interopDefault(
        import(
          /* webpackChunkName: 'employee:organization' */ '~/pages/tenantmember/organizations/show.vue'
        )
      ),
    children: [
      {
        path: '',
        name: RouteEnum.ORGANIZATION.DETAILS,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.details' */ '~/pages/tenantmember/organizations/details.vue'
            )
          ),
      },
      {
        path: 'profiles',
        name: RouteEnum.ORGANIZATION.PROFILES,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.profiles' */ '~/pages/tenantmember/organizations/profiles/index.vue'
            )
          ),
      },
      {
        path: 'profiles/create',
        name: RouteEnum.PROFILES.CREATE,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:profiles.edit-create' */ '~/pages/tenantmember/organizations/profiles/edit-create.vue'
            )
          ),
      },
      {
        path: 'profiles/:profile_id/edit',
        name: RouteEnum.PROFILES.EDIT,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:profiles.edit-create' */ '~/pages/tenantmember/organizations/profiles/edit-create.vue'
            )
          ),
      },
      {
        path: 'employees',
        name: RouteEnum.ORGANIZATION.EMPLOYEES,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.employees' */ '~/pages/tenantmember/organizations/employees/index.vue'
            )
          ),
      },
      {
        path: 'invitations',
        name: RouteEnum.ORGANIZATION.INVITATIONS,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.invitations' */ '~/pages/tenantmember/organizations/invitations/index.vue'
            )
          ),
      },
      {
        path: 'registration-codes',
        name: RouteEnum.ORGANIZATION.REGISTRATION_CODES,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.registration-codes' */ '~/pages/tenantmember/organizations/registration-codes/index.vue'
            )
          ),
      },
      {
        path: 'registration-codes/create',
        name: RouteEnum.REGISTRATION_CODES.CREATE,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.registration-codes.edit-create' */ '~/pages/tenantmember/organizations/registration-codes/edit-create.vue'
            )
          ),
      },
      {
        path: 'registration-codes/:registration_code_id/edit',
        name: RouteEnum.REGISTRATION_CODES.EDIT,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.registration-codes.edit-create' */ '~/pages/tenantmember/organizations/registration-codes/edit-create.vue'
            )
          ),
      },
      {
        path: 'email-templates',
        name: RouteEnum.ORGANIZATION.EMAIL_TEMPLATES,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.email-templates' */ '~/pages/tenantmember/organizations/email-templates/index.vue'
            )
          ),
      },
      {
        path: 'email-templates/create',
        name: RouteEnum.EMAIL_TEMPLATES.CREATE,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.email-templates.edit-create' */ '~/pages/tenantmember/organizations/email-templates/edit-create.vue'
            )
          ),
      },
      {
        path: 'email-templates/:email_template_id/edit',
        name: RouteEnum.EMAIL_TEMPLATES.EDIT,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.email-templates.edit-create' */ '~/pages/tenantmember/organizations/email-templates/edit-create.vue'
            )
          ),
      },
      {
        path: 'pings',
        name: RouteEnum.ORGANIZATION.PINGS,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.pings' */ '~/pages/tenantmember/organizations/pings/index.vue'
            )
          ),
      },
      {
        path: 'alerts',
        name: RouteEnum.ORGANIZATION.ALERTS,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.alerts' */ '~/pages/tenantmember/organizations/alerts/index.vue'
            )
          ),
      },
      {
        path: 'alerts/create',
        name: RouteEnum.ALERTS.CREATE,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.alerts/edit-create' */ '~/pages/tenantmember/organizations/alerts/edit-create.vue'
            )
          ),
      },
      {
        path: 'alerts/:alert_id/edit',
        name: RouteEnum.ALERTS.EDIT,
        component: () =>
          interopDefault(
            import(
              /* webpackChunkName: 'tenantmember:organization.alerts/edit-create' */ '~/pages/tenantmember/organizations/alerts/edit-create.vue'
            )
          ),
      },
    ],
  },
];
